import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  checkmark: {
    fill: theme.palette.common.blue400,
    fontSize: theme.spacing(2),
  },
  option: {
    '&.focused': {
      backgroundColor: theme.palette.common.gray100,
    },
    '&.inactive': {
      pointer: 'not-allowed',
      pointerEvents: 'none',
    },
    '&.selected': {
      backgroundColor: theme.palette.common.blue100,
      color: theme.palette.common.blue600,
    },
    '&:hover': {
      backgroundColor: theme.palette.common.gray100,
    },
    borderRadius: 3,
    cursor: 'pointer',
    padding: theme.spacing(1.5, 2),
  },
  optionLabel: {
    '&.disabled': {
      color: theme.palette.common.gray500,
    },

    '&.selected': {
      color: theme.palette.common.blue400,
    },

    whiteSpace: 'nowrap',
  },
  truncated: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export default useStyles;
